import { Injectable } from '@angular/core';
import { UserProvider } from './user';
import { BaseProvider } from './base';

export enum SupportEmail {
    Default = 'support@neurala.com',
    SonyAitrios = 'aitrios-support@neurala.com'
}

@Injectable()
export class SupportProvider extends BaseProvider {
    constructor(private userProvider: UserProvider) {
        super();
    }

    public getSupportEmail(): string {
        const userInformation = this.userProvider.getUserInformation();
        const hasEmail = userInformation.email;

        if (hasEmail && this.userProvider.isSonyUser()) {
            return SupportEmail.SonyAitrios;
        }

        return SupportEmail.Default;
    }
}



// WEBPACK FOOTER //
// ./src/providers/support.ts